export default __webpack_public_path__ + "static/media/dac-qr.de5db293.png";